import { zodResolver } from '@hookform/resolvers/zod';
import { useForm, UseFormProps } from 'react-hook-form';

import {
	type AiSequenceSchemaProps,
	aiSequenceSchema
} from '@/schemas/aiSequence/schema';

export const useFormValidation = (
	props?: UseFormProps<AiSequenceSchemaProps>
) =>
	useForm<AiSequenceSchemaProps>({
		resolver: zodResolver(aiSequenceSchema),
		...props
	});
